import { DataSourcesQueries } from '@frontend/api-data-sources';

export const useGetAppointmentColorsEnabled = () => {
  const { isIntegratedOffice } = DataSourcesQueries.useGetAccessibleIntegrations();

  return { canUseAppointmentColors: !isIntegratedOffice };
};
